<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" [routerLink]="'/office/new-certification'">chevron_left</mat-icon>
            <h1 class="page-title">Add New Certification</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/new-certification'">Certifications</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">Add New Certification</span>
        </div>
    </div>

    <hr class="mb-3" />

    <form [formGroup]="form" (keydown.enter)="$event.preventDefault()">
        <div class="row mt-2">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Certification Title</mat-label>
                    <input type="text" matInput formControlName="certificationTitle">
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Association</mat-label>
                    <mat-select formControlName="providerId">
                        <mat-option *ngFor="let assoc of associations" [value]="assoc.id">
                            {{ assoc.providerName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-6">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>CEU Required</mat-label>
                    <span matSuffix style="margin-right: 10px;">CEU</span>
                    <input style="padding-top: 3px;" class="text-end" type="number" matInput formControlName="ceuRequired">
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Certification Duration</mat-label>
                    <span matSuffix style="margin-right: 10px;">Year</span>
                    <input style="padding-top: 3px;" class="text-end" type="number" matInput formControlName="duration">
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-6">
                <mat-form-field class="full-width w-100 " appearance="outline">
                    <mat-label>Certification Price</mat-label>
                    <span matPrefix style="margin-left: 10px;">$</span>
                    <input style="padding-top: 3px;" class="text-end" type="number" matInput formControlName="price">
                </mat-form-field>

            </div>
        </div>

        <mat-label class="text-color-black-normal-50 mt-2">Attendance Type</mat-label>

        <div class="card-bg-20 rounded-2 p-3 mt-2 mb-4">
            <div *ngFor="let at of attendanceTypes.parameterMembers; let x = index">
                <mat-checkbox (change)="addRemoveAttendanceType($event, at.parameterValue, at.parameterLabel)"  [value]="at.parameterValue">
                    {{at.parameterLabel}}
                </mat-checkbox>
            </div>

        </div>

        <mat-label class="text-color-black-normal-50 mt-2">Activities</mat-label>
        <app-certification-condition-check-list
                [form]="form"
                (activityChecked)="addRemoveActivity($event)">
        </app-certification-condition-check-list>

        <h5 style="font-size: 16px" class="mt-3 text-white">Certification Domain and Objectives</h5>
        <mat-accordion multi formArrayName="domains">
            <mat-expansion-panel [expanded]="true" *ngFor="let domain of domains.controls; let i = index" [formGroupName]="i">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="title-container">
                            <span>Domain {{ i + 1 }}</span>
                            <mat-icon (click)="removeDomain(i); $event.stopPropagation()" class="button-flat crimson-red">delete</mat-icon>
                        </div>

                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="p-1 expansion-body">
                    <div class="row mt-4">
                        <div class="col-12">
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Domain Name</mat-label>
                                <input type="text" matInput formControlName="domainName">
                            </mat-form-field>
                        </div>
                    </div>

                    <hr class="mb-4" />

                    <mat-accordion class="mb-5" multi formArrayName="objectives">
                        <mat-expansion-panel [expanded]="true" *ngFor="let objective of objectives(i).controls; let j = index" [formGroupName]="j">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div class="title-container">
                                        <span>Target Objective {{ j + 1 }}</span>
                                        <mat-icon (click)="removeObjective(i, j); $event.stopPropagation()" class="button-flat crimson-red">delete</mat-icon>
                                    </div>

                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <div class="p-1 expansion-body">
                                <div class="row mt-4">
                                    <div class="col-12">
                                        <mat-form-field class="full-width w-100" appearance="outline">
                                            <mat-label>Target Objective Name</mat-label>
                                            <input type="text" matInput formControlName="objectiveName">
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row ">
                                    <div class="col-12">
                                        <app-tiptap-editor
                                                placeholder="Enter your content here..."
                                                formControlName="term"
                                                label="Exam objective terms"
                                                [required]="true"
                                        >
                                        </app-tiptap-editor>
                                    </div>
                                </div>

                            </div>


                        </mat-expansion-panel>
                    </mat-accordion>

                    <div class="p-1 text-center">
                        <div class="d-inline-flex mt-5 gap-3 add-new-activity button-flat" (click)="addObjective(i)">
                            <mat-icon class="gap-2">add</mat-icon><span class="d-block mt-1">Add More Objective</span>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>


        </mat-accordion>
        <div class="d-inline-flex mt-5 gap-3 add-new-activity button-flat" (click)="addDomain()">
            <mat-icon class="gap-2">add</mat-icon><span class="d-block mt-1">Add More Domain</span>
        </div>

        <div class="row my-5">
            <div class="col-12 text-end">
                <button type="button" mat-raised-button (click)="saveCertification()"  class="edit-button">Save</button>
            </div>
        </div>
    </form>
</div>

